import React, { Component, ErrorInfo, ReactNode } from "react";
import { useNavigate } from "react-router-dom";

type Props = { children: ReactNode };
type State = { hasError: boolean };

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("ErrorBoundary caught an error", error, info);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback />;
    }

    return this.props.children;
  }
}

const ErrorFallback = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-black text-white px-3 text-center">
        <div className="d-flex flex-column flex-md-row align-items-center custom-divider text-start">
          <h1 className="display-4 fw-bold me-md-3 pe-md-3 mb-3 mb-md-0 border-md-end border-secondary">
            Something went wrong!
          </h1>
          <p className="lead m-0">
            We’re working to fix it. You can try again or go to home.
          </p>
        </div>

        {/* <div className="mt-4 d-flex flex-column flex-sm-row gap-3">
          <button
            className="btn btn-outline-light btn-lg px-4 py-2"
            onClick={() => navigate(-1)}
          >
            Go Back
          </button>
          <button
            className="btn btn-primary btn-lg px-4 py-2"
            onClick={() => navigate("/")}
          >
            Home
          </button>
        </div> */}

        <div className="mt-4 d-flex flex-column flex-sm-row gap-3">
          <button
            className="btn btn-outline-light btn-lg px-4 py-2"
            onClick={() => window.location.reload()}
          >
            Try Again
          </button>
          <a href="/" className="btn btn-primary btn-lg px-4 py-2">
            Home
          </a>
        </div>
      </div>

      {/*  */}
      {/* 
      <div className="text-center p-10">
        <h1 className="text-4xl font-bold text-red-600">
          Something went wrong!
        </h1>
        <p className="text-gray-600 mt-2">
          We’re working to fix it. You can try again or go to home.
        </p>
        <div className="mt-4 space-x-4">
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600"
          >
            🔄 Try Again
          </button>
          <button
            onClick={() => navigate("/")}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            🏠 Home
          </button>
        </div>
      </div> */}
    </>
  );
};

export default ErrorBoundary;
